module.exports = __webpack_public_path__ + "static/media/test1.bcccc6b9.png";